import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { API_URL } from "../../common/config";
import { getHeader } from "../../api/api";
import ImageRenderer from "./ImageRenderer";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

class FileViewer extends Component {
  shouldComponentUpdate(nextProps) {
    return false;
  }

  render() {
    console.log(ImageRenderer.fileTypes);

    return (
      <React.Fragment>
        <DocViewer
          pluginRenderers={[...DocViewerRenderers, ImageRenderer]}
          documents={[
            {
              uri: API_URL + "/file/download/" + this.props.sign,
              fileName: this.props.name,
            },
          ]}
          prefetchMethod="GET"
          requestHeaders={getHeader()}
        />
      </React.Fragment>
    );
  }
}

export default withTranslation()(FileViewer);